/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 納品（受入）可能フラグ（月曜日）
 * @export
 * @interface EnableArrivalMon
 */
export interface EnableArrivalMon {
}

/**
 * Check if a given object implements the EnableArrivalMon interface.
 */
export function instanceOfEnableArrivalMon(value: object): value is EnableArrivalMon {
    return true;
}

export function EnableArrivalMonFromJSON(json: any): EnableArrivalMon {
    return EnableArrivalMonFromJSONTyped(json, false);
}

export function EnableArrivalMonFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnableArrivalMon {
    return json;
}

export function EnableArrivalMonToJSON(json: any): EnableArrivalMon {
    return EnableArrivalMonToJSONTyped(json, false);
}

export function EnableArrivalMonToJSONTyped(value?: EnableArrivalMon | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

